// Uvunaji.jsx — Main tab container
// Adds "Yield Dummy Products" as a proper tab alongside Assets and Investments

import React, { useState } from 'react';
import UvunajiAssets from '../components/UvunajiAssets';
import UvunajiInvestment from '../components/UvunajiInvestment';
import UvunajiDummyProducts from '../components/UvunajiDummyProducts';
import {
  FiPackage, FiTrendingUp, FiShoppingBag,
  FiFolder, FiBarChart2,
} from 'react-icons/fi';

const TABS = [
  {
    id:          'assets',
    label:       'Assets',
    icon:        FiPackage,
    description: 'Manage Yield Crops, Livestock and Asset investments',
    content:     <UvunajiAssets />,
  },
  {
    id:          'investments',
    label:       'Investments',
    icon:        FiTrendingUp,
    description: 'View and track all user investments',
    content:     <UvunajiInvestment />,
  },
  {
    id:          'dummy',
    label:       'Yield Dummy Products',
    icon:        FiShoppingBag,
    description: 'Manage tradable product categories, products and orders',
    content:     <UvunajiDummyProducts />,
  },
];

function Uvunaji() {
  const [activeTab, setActiveTab] = useState('assets');
  const current = TABS.find((t) => t.id === activeTab);

  return (
    <div className="min-h-screen bg-gray-50">

      {/* ── Page header ── */}
      <div className="bg-white border-b border-gray-200">
        <div className="max-w-8xl mx-auto px-4 sm:px-6 lg:px-8 py-6">

          <div className="flex items-center gap-3 mb-6">
            <FiFolder className="h-7 w-7 text-blue-600" />
            <div>
              <h1 className="text-2xl font-bold text-gray-900">Uvunaji Management</h1>
              <p className="text-sm text-gray-500 mt-0.5">
                Comprehensive asset, investment and tradable product management
              </p>
            </div>
          </div>

          {/* ── Tab bar ── */}
          <div className="flex space-x-1 bg-gray-100 p-1 rounded-lg">
            {TABS.map((tab) => {
              const Icon     = tab.icon;
              const isActive = activeTab === tab.id;
              return (
                <button
                  key={tab.id}
                  onClick={() => setActiveTab(tab.id)}
                  className={`
                    flex items-center gap-2 px-6 py-3 rounded-md font-medium text-sm
                    transition-all duration-200 ease-in-out flex-1 justify-center
                    ${isActive
                      ? 'bg-white text-blue-600 shadow-sm'
                      : 'text-gray-600 hover:text-gray-900 hover:bg-gray-50'
                    }
                  `}
                >
                  <Icon className={`h-4 w-4 ${isActive ? 'text-blue-600' : 'text-gray-500'}`} />
                  <span>{tab.label}</span>
                  {isActive && (
                    <span className="ml-1 inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-blue-100 text-blue-800">
                      Active
                    </span>
                  )}
                </button>
              );
            })}
          </div>

          {/* ── Active tab description ── */}
          {current && (
            <div className="mt-4 flex items-center gap-2 text-sm text-gray-500">
              <FiBarChart2 className="h-4 w-4" />
              <span>{current.description}</span>
            </div>
          )}
        </div>
      </div>

      {/* ── Tab content ── */}
      <div className="max-w-8xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <div className="transition-all duration-300 ease-in-out">
          {current && current.content}
        </div>
      </div>
    </div>
  );
}

export default Uvunaji;
// import React, { useState } from 'react';
// import UvunajiAssets from '../components/UvunajiAssets';
// import UvunajiInvestment from '../components/UvunajiInvestment';
// import { FiPackage, FiTrendingUp, FiFolder, FiBarChart2 } from 'react-icons/fi';

// const uvunajiTabs = [
//   { 
//     id: 'assets',
//     label: "Assets", 
//     icon: FiPackage, 
//     content: <UvunajiAssets />,
//     description: "Manage investment assets and inventory"
//   },
//   { 
//     id: 'investments',
//     label: "Investments", 
//     icon: FiTrendingUp, 
//     content: <UvunajiInvestment />,
//     description: "View and track user investments"
//   },
// ];

// function Uvunaji() {
//   const [selectedTab, setSelectedTab] = useState('assets');

//   const activeTab = uvunajiTabs.find(tab => tab.id === selectedTab);

//   return (
//     <div className="min-h-screen bg-gray-50">
//       {/* Header Section */}
//       <div className="bg-white border-b border-gray-200">
//         <div className="max-w-8xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
//           <div className="flex items-center justify-between mb-6">
//             <div>
//               <h1 className="text-2xl font-bold text-gray-900 flex items-center gap-2">
//                 <FiFolder className="h-7 w-7 text-blue-600" />
//                 Uvunaji Management
//               </h1>
//               <p className="mt-1 text-sm text-gray-500">
//                 Comprehensive asset and investment management system
//               </p>
//             </div>
//           </div>

//           {/* Tab Navigation */}
//           <div className="flex space-x-1 bg-gray-100 p-1 rounded-lg">
//             {uvunajiTabs.map((tab) => {
//               const Icon = tab.icon;
//               const isActive = selectedTab === tab.id;
              
//               return (
//                 <button
//                   key={tab.id}
//                   onClick={() => setSelectedTab(tab.id)}
//                   className={`
//                     flex items-center gap-2 px-6 py-3 rounded-md font-medium text-sm
//                     transition-all duration-200 ease-in-out flex-1 justify-center
//                     ${isActive 
//                       ? 'bg-white text-blue-600 shadow-sm' 
//                       : 'text-gray-600 hover:text-gray-900 hover:bg-gray-50'
//                     }
//                   `}
//                 >
//                   <Icon className={`h-5 w-5 ${isActive ? 'text-blue-600' : 'text-gray-500'}`} />
//                   <span>{tab.label}</span>
//                   {isActive && (
//                     <span className="ml-2 inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-blue-100 text-blue-800">
//                       Active
//                     </span>
//                   )}
//                 </button>
//               );
//             })}
//           </div>

//           {/* Active Tab Description */}
//           {activeTab && (
//             <div className="mt-4 flex items-center gap-2 text-sm text-gray-600">
//               <FiBarChart2 className="h-4 w-4" />
//               <span>{activeTab.description}</span>
//             </div>
//           )}
//         </div>
//       </div>

//       {/* Tab Content */}
//       <div className="max-w-8xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
//         <div className="transition-all duration-300 ease-in-out">
//           {activeTab && activeTab.content}
//         </div>
//       </div>
//     </div>
//   );
// }

// export default Uvunaji;